import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import RegularButton from 'components/CustomButtons/Button';

import { WithApp } from 'contexts/appContext';
import { Switch } from '@material-ui/core';
import { wsCreate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Bureau(props) {
  const classes = useStyles();
  const { supervisor, updateState } = props;
  const [processing, setProcessing] = useState(false);

  async function regenerateBureaus() {
    setProcessing(true);
    let res = await wsCreate(`base/supervisor/${supervisor.id}/regenerate-bureaus`);
    window.alert(res.message);
    setProcessing(false);
  }

  return (
    <GridItem xs={12}>
      <GridItem xs={12}>
        <RegularButton color="warning" onClick={regenerateBureaus} disabled={processing}>
          Regenerar
        </RegularButton>
      </GridItem>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de Mesas</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={'Supervisor-mesas-' + supervisor.dni}
            defaultWidth={1200}
            indexRow={[0, 5]}
            widthRow={[100, 5]}
            columns={columns}
            data={
              supervisor.bureaus?.map((item, i) => {
                return {
                  num: i + 1,
                  code: item.code,
                  base_zone_description: supervisor.zones.find(
                    (x) => x.id == item.pivot.base_zone_id,
                  )?.description,
                  description: item.description,
                  state: (
                    <Switch
                      checked={item.pivot.state === 'A' ? true : false}
                      onChange={() =>
                        updateState('bureau', item.id, {
                          state: item.pivot.state === 'A' ? 'I' : 'A',
                        })
                      }
                      color="secondary"
                    />
                  ),
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </GridItem>
  );
});
